<template>
    <div v-if="selectedBiz.tax_id === '0107544000094'" class="font-theme" style="margin: 0 2% 3.61% 2%;"
        v-resize="onResize">
        <v-row class="standard-row mb-2" style="padding: 10px 2.4% 0 2%;" no-gutters>
            <v-col class="d-flex justify-start">
                <v-btn class="font-theme font-header-tabs-eval" height="52" depressed rounded text to="/eval_vendor">
                    &lt; กลับหน้ากล่องเอกสาร
                </v-btn>
            </v-col>
             <v-col v-if="windowSize.x >= 677" class="d-flex justify-end">
                <v-btn rounded color="#ffffff" class="black--text text-center download-report-vendor-btn mr-2"
                    @click="downloadFile">
                    <img src="../assets/excel.png" alt="Excel Icon" width="30" class="mr-2" />
                    ตัวอย่างประเมินผู้ขาย
                </v-btn>
                <v-btn rounded color="green" class="white--text text-center download-report-vendor-btn"
                    @click="addFileExcelEvalVendor">
                    <v-icon class="mr-1">mdi-plus</v-icon>
                    Import Excel
                </v-btn>
            </v-col>
            <v-col v-else class="d-flex mb-2 justify-center align-center">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" rounded color="#ffffff"
                            class="black--text text-center download-report-vendor-btn mr-2" @click="downloadFile">
                            <img src="../assets/excel.png" alt="Excel Icon" width="30" />
                        </v-btn>
                    </template>
                    <span class="font-theme">ตัวอย่างประเมินผู้ขาย</span>
                </v-tooltip>
                <v-btn rounded color="green" class="white--text text-center download-report-vendor-btn"
                    @click="addFileExcelEvalVendor">
                    <v-icon class="mr-1">mdi-plus</v-icon> Import Excel
                </v-btn>
            </v-col>
        </v-row>
        <div class="card-external font-theme mt-0" style="padding: 10px 2.4% 1% 2.7%;" v-resize="onResize">
            <v-row v-if="selectedBiz.tax_id === '0107544000094'" no-gutters
                class="standard-row font-for-header-tabs-eval-vendor d-flex justify-space-between" align="center"
                style="font-weight: 700; padding: 21px 1% 1% 1%;">
                <v-row align="center" justify="space-between">
                    <v-col class="d-flex justify-start">
                        <v-slide-group v-if="windowSize.x > 434" show-arrows mandatory v-model="permissionTabs"
                            color="black">
                            <v-slide-item v-if="permissionEval.includes('จัดซื้อ')" v-slot="{ active, toggle }"
                                value="ALL">
                                <v-btn :input-value="active" active-class="select-header-tabs-eval-vendor"
                                    class="font-for-header-tabs-eval-vendor" @click="toggle" height="58px" depressed
                                    rounded text>
                                    All
                                </v-btn>
                            </v-slide-item>
                            <v-slide-item v-if="permissionEval.includes('INBOX') || permissionEval.includes('จัดซื้อ')"
                                v-slot="{ active, toggle }" value="INBOX">
                                <v-btn :input-value="active" active-class="select-header-tabs-eval-vendor"
                                    class="font-for-header-tabs-eval-vendor" @click="toggle" height="58px" depressed
                                    rounded text>
                                    User
                                </v-btn>
                            </v-slide-item>
                            <v-slide-item v-if="permissionEval.includes('จัดซื้อ')" v-slot="{ active, toggle }"
                                value="จัดซื้อ">
                                <v-btn :input-value="active" active-class="select-header-tabs-eval-vendor"
                                    class="font-for-header-tabs-eval-vendor" @click="toggle" height="58px" depressed
                                    rounded text>
                                    จัดซื้อ
                                </v-btn>
                            </v-slide-item>
                        </v-slide-group>
                        <v-select v-else
                            :items="permissionEval.includes('จัดซื้อ') ? permissionEvalItem : permissionEvalInbox"
                            hide-details outlined dense height="30" item-text="name" item-value="value"
                            v-model="permissionTabs" append-icon="mdi-chevron-down" background-color="white"
                            item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }"
                            class="custom-search-dropdown-eval-vender">
                            <template v-slot:item="{ item }">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme"
                                        style="font-size: 15px; font-weight: 700; line-height: 30px;">
                                        {{ item.name }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col v-if="windowSize.x >= 918" class="d-flex justify-end align-center gap-4">
                        <v-select :items="filteredDropdown" item-text="name" item-value="value"
                            v-model="filteredDropdownValue" @change="getReportEvalVender()()" hide-details outlined dense height="36"
                            append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black"
                            :menu-props="{ bottom: true, offsetY: true }" class="font-theme custom-search-dropdown mr-2"
                            style="max-width: 220px;">
                            <template v-slot:item="data">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme" style="line-height: 30px;">
                                        {{ data.item.name }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </v-select>
                        <v-btn class="mr-2 blue-btn font-theme" to="/summary_eval_vendor">Summary</v-btn>
                        <v-btn class="blue-btn font-theme" @click="goToDownloadReport()">Download</v-btn>
                    </v-col>
                    <v-col v-else-if="windowSize.x >= 443" cols="12" lg="12"
                        class="d-flex justify-start align-center gap-4">
                        <v-select :items="filteredDropdown" item-text="name" item-value="value"
                            v-model="filteredDropdownValue" @change="getReportEvalVender()()" hide-details outlined dense height="36"
                            append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black"
                            :menu-props="{ bottom: true, offsetY: true }" class="font-theme custom-search-dropdown mr-2"
                            style="max-width: 220px;">
                            <template v-slot:item="data">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme" style="line-height: 30px;">
                                        {{ data.item.name }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </v-select>
                        <v-btn class="mr-2 blue-btn font-theme" to="/summary_eval_vendor">Summary</v-btn>
                        <v-btn class="blue-btn font-theme" @click="goToDownloadReport()">Download</v-btn>
                    </v-col>
                    <v-col v-else cols="12" lg="12">
                        <v-select :items="filteredDropdown" item-text="name" item-value="value"
                            v-model="filteredDropdownValue" @change="getReportEvalVender()()" hide-details outlined dense height="36"
                            append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black"
                            :menu-props="{ bottom: true, offsetY: true }" class="custom-search-dropdown-eval-vender">
                            <template v-slot:item="data">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme" style="line-height: 30px;">
                                        {{ data.item.name }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </v-select>
                        <v-btn class="mt-5  mr-2 blue-btn font-theme" to="/summary_eval_vendor">Summary</v-btn>
                        <v-btn class="mt-5 blue-btn font-theme" @click="goToDownloadReport()">Download</v-btn>
                    </v-col>
                </v-row>
            </v-row>
            <v-row no-gutters class="standard-row">
                <div style="padding: 1.2% 1.2% 1.2% 1.2%; width: 100%;">
                    <v-data-table :headers="headers" :items="myReportEvalVenders" fixed-header
                        class="elevation-0 data-table-eval-report" :options.sync="optionsTransaction"
                        :server-items-length="countMyReportEvalVenders" :footer-props="{ 'items-per-page-options': [20, 30, 40, 50], 'items-per-page-text': 'จำนวนแถวต่อหน้า' }" mobile-breakpoint="601">
                        <template slot="no-data">
                            <v-alert class="text-center d-flex justify-center">
                                ไม่พบข้อมูล
                            </v-alert>
                        </template>
                        <template v-slot:no-results>
                            <v-alert class="text-center d-flex justify-center">
                                ไม่พบข้อมูล
                            </v-alert>
                        </template>
                        <template v-slot:[`footer.page-text`]="items">
                        {{ items.pageStart }} - {{ items.pageStop }} จาก {{ items.itemsLength }} แถว
                        </template>
                    </v-data-table>
                </div>
            </v-row>
            <DownloadReportModal />
            <ExcelEvalVendor />
        </div>
    </div>

</template>

<script>
import { MainFunction } from '@/functions/mainFunction';
import { EventBus } from '../EventBus'
import DownloadReportModal from '../components/DownloadReportModal.vue'
import ExcelEvalVendor from '../components/addExcelEvalVendorModal.vue'
export default {
    components: {
        DownloadReportModal,
        ExcelEvalVendor
    },
    data: () => ({
        windowSize: { x: 0, y: 0 },
        loadingData: false,
        headers: [
            { text: "ประทับเวลา", value: "created_at", align: "center", sortable: false, width: 190 },
            { text: "เลขที่ใบสั่งซื้อ (PO)", value: "po_number", align: "center", sortable: false, width: 190 },
            { text: "วันที่ประเมิน", value: "doc_date", align: "center", sortable: false, width: 190 },
            { text: "ชื่อบริษัทผู้ขาย", value: "vendor_name", align: "center", sortable: false, width: 190 },
            { text: "อุปกรณ์/สินค้า/บริการ สามารถตรวจรับได้หรือไม่", value: "detail_vendor", align: "center", sortable: false, width: 350 },
            { text: "โปรดระบุวันที่ตรวจรับ", value: "receipt_date", align: "center", sortable: false, width: 190 },
            { text: "คุณภาพ Quality", value: "Quality", align: "center", sortable: false, width: 120 },
            { text: "ราคา Price", value: "Price", align: "center", sortable: false, width: 120 },
            { text: "การส่งมอบ Delivery", value: "Delivery", align: "center", sortable: false, width: 150 },
            { text: "บริการ Service", value: "Service", align: "center", sortable: false, width: 190 },
            { text: "รวมคะแนน User", value: "sum_inbox_raw", align: "center", sortable: false, width: 190 },
            { text: "คุณภาพ Quality สำหรับจัดซื้อ", value: "quality_purch", align: "center", sortable: false, width: 200 },
            { text: "ราคา Price สำหรับจัดซื้อ", value: "price_purch", align: "center", sortable: false, width: 190 },
            { text: "การส่งมอบ Delivery สำหรับจัดซื้อ", value: "delivery_purch", align: "center", sortable: false, width: 220 },
            { text: "บริการ Service สำหรับจัดซื้อ", value: "service_purch", align: "center", sortable: false, width: 190 },
            { text: "รวมคะแนนจัดซื้อ", value: "sum_purchase_raw", align: "center", sortable: false, width: 190 },
            { text: "รวมคะแนนทั้งหมด (User+จัดซื้อ)", value: "total_score", align: "center", sortable: false, width: 220 },
            { text: "รวมคะแนนที่ได้ (x2.5)", value: "total_score_weighted", align: "center", sortable: false, width: 190 },
            { text: "เกรด", value: "grade", align: "center", sortable: false, width: 100 },
        ],
        permissionEvalItem: [
            { name: 'All', value: 'ALL' },
            { name: 'User', value: 'INBOX' },
            { name: 'จัดซื้อ', value: 'จัดซื้อ' }
        ],
        permissionEvalInbox: [
            { name: 'User', value: 'INBOX' }
        ],
        myReportEvalVenders: [],
        permissionTabs: '',
        countMyReportEvalVenders: 0,
        callApiPending: 0,
        filteredDropdown: [],
        filteredDropdownValue:null,
        optionsTransaction: {
            "page": 1,
            "itemsPerPage": 20
        },
    }),
    watch: {
        "permissionTabs"() {
            this.optionsTransaction.page = 1
            this.getReportEvalVender()
        },
        "optionsTransaction.page"(newValue) {
            if (newValue != 1 || !this.isChangeTab) {
                this.getReportEvalVender()
                this.trigRowPerPage = true
            }
        },
        "optionsTransaction.itemsPerPage"() {
            if (!this.trigRowPerPage) {
                this.optionsTransaction.page = 1
                this.getReportEvalVender()
            }
        },
        "callApiPending"(val) {
            if (val > 0) {
                EventBus.$emit('loadingState', true)
            } else {

                EventBus.$emit('loadingState', false)
            }
        },
    },
    computed: {
        selectedBiz() {
            return this.$store.state.confirmSelectedBiz
        },
        permissionEval() {
            return this.$store.state.permissionEval
        }
    },
    mounted() {
        this.onResize()
        if (this.permissionEval?.includes('จัดซื้อ')) {
            this.permissionTabs = 'ALL';
        } else {
            this.permissionTabs = 'INBOX';
        }
        if (this.selectedBiz.tax_id === '0107544000094') {
            EventBus.$on('openEvalReportModal', this.getReportEvalVender)
        }
        this.generateFilteredDropdown()
        this.getDefaultFilteredDropdown()
    },
    beforeDestroy() {
        EventBus.$off('openEvalReportModal')
    },
    methods: {
        onResize() {
            this.windowSize = { x: window.innerWidth, y: window.innerHeight }
        },
        async getReportEvalVender() {
            try {
                this.callApiPending++;
                const response = await this.axios({
                    baseURL: this.$api_url,
                    url: `/saler_score/api/v1/report`,
                    method: 'GET',
                    params: {
                        "inbox": this.permissionTabs,
                        "limit": this.optionsTransaction.itemsPerPage || 20,
                        "offset": this.optionsTransaction.page,
                        "filter_quater" : this.filteredDropdownValue,
                    }
                });
                this.countMyReportEvalVenders = response.data.totalCount;
                this.myReportEvalVenders = response.data.data.map(item => ({
                    created_at : `${MainFunction.shortDate(item.created_at)} ${MainFunction.shortTime(item.created_at)}`,
                    po_number: item.po_number,
                    vendor_name: item.vendor_name,
                    detail_vendor: item.detail_vendor,
                    sum_inbox_raw:item.sum_inbox_raw,
                    doc_date : MainFunction.shortDate(item.doc_date),
                    receipt_date: MainFunction.shortDate(item.receipt_date) || "-",
                    Quality: item.evaluations.find(e => e.eval_type === "INBOX")?.eval_vendor_scores.find(e => e.eval_name.trim() === "Quality")?.score,
                    Price: item.evaluations.find(e => e.eval_type === "INBOX")?.eval_vendor_scores.find(e => e.eval_name.trim() === "Price")?.score,
                    Delivery: item.evaluations.find(e => e.eval_type === "INBOX")?.eval_vendor_scores.find(e => e.eval_name.trim() === "Delivery")?.score,
                    Service: item.evaluations.find(e => e.eval_type === "INBOX")?.eval_vendor_scores.find(e => e.eval_name.trim() === "Service")?.score,

                    service_purch :item.evaluations.find(e => e.eval_type === "จัดซื้อ")?.eval_vendor_scores.find(e => e.eval_name.trim() === "Service")?.score,
                    price_purch :item.evaluations.find(e => e.eval_type === "จัดซื้อ")?.eval_vendor_scores.find(e => e.eval_name.trim() === "Price")?.score,
                    delivery_purch :item.evaluations.find(e => e.eval_type === "จัดซื้อ")?.eval_vendor_scores.find(e => e.eval_name.trim() === "Delivery")?.score,
                    quality_purch: item.evaluations.find(e => e.eval_type === "จัดซื้อ")?.eval_vendor_scores.find(e => e.eval_name.trim() === "Quality")?.score,
                    
                    sum_purchase_raw :item.sum_purchase_raw,
                    total_score : item.total_score,
                    total_score_weighted: item.total_score_weighted,
                    grade: item.grade
                }));
            } catch (error) {
                console.error(error);
                this.myReportEvalVenders = [];
            } finally {
                this.callApiPending--;
                if (!this.callApiPending) this.isReady = true;
            }
        },
        goToDownloadReport() {
            const aboutReport = {
                url: '/report/api/v1/export',
                from: 'evalVendor',
                inbox: this.permissionTabs
            }
            EventBus.$emit('openDownloadReportModal', aboutReport)
        },
        generateFilteredDropdown() {
            this.year = new Date().getFullYear();
            this.filteredDropdown = [
                { name: `ประเมินรอบ 1/${this.year}`, value: 'Q1' },
                { name: `ประเมินรอบ 2/${this.year}`, value: 'Q2' },
                { name: `ประเมินรอบ 3/${this.year}`, value: 'Q3' },
                { name: `ประเมินรอบ 4/${this.year}`, value: 'Q4' }
            ];
        },
        getDefaultFilteredDropdown() {
            const now = new Date();
            const month = now.getMonth() + 1;
            if (month >= 1 && month <= 3) {
                this.filteredDropdownValue = 'Q1';
            } else if (month >= 4 && month <= 6) {
                this.filteredDropdownValue = 'Q2';
            } else if (month >= 7 && month <= 9) {
                this.filteredDropdownValue = 'Q3';
            } else {
                this.filteredDropdownValue = 'Q4';
            }
        },
        addFileExcelEvalVendor() {
            EventBus.$emit('addFileExcelEvalVendor', 'Item')
        },
        downloadFile() {
            const link = document.createElement('a');
            link.href = '/file/รูปแบบการนำเข้าข้อมูลประเมินผู้ขาย.xlsx'; // Path relative to the public directory
            link.download = 'รูปแบบการนำเข้าข้อมูลประเมินผู้ขาย.xlsx'; // Adjust the download file name as necessary
            link.click();
            this.alert('ดาวน์โหลดไฟล์สำเร็จ', 'Success', 'success');
        },
        alert(title = '', text = 'Warning', icon = 'info') {
                this.$swal({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    icon: icon,
                    title: `<b class="alert-success-title">${title}</b>`,
                    text:  text,
                    showClass: {
                        popup: 'animate-show-card'
                    },
                    customClass: {
                        container: 'alert-card-block',
                        popup: 'alert-card-success',
                        title: 'alert-title-block',
                        htmlContainer: 'alert-text-box',
                        icon: 'alert-icon'
                    }
                })
            }
    }
}
</script>

<style>
.card-external {
    background: white !important;
    box-shadow: 0px 4px 50px 20px rgba(0, 0, 0, 0.25);
    border-radius: 23px;
    margin: 60px 2% 3.61% 2%;
}

.blue-btn {
    background-color: #1976D2 !important;
    color: white !important;
    border-radius: 25px;
    font-weight: 700;
}

.data-table-eval-report thead th {
    height: 49px !important;
    background-color: #333333 !important;
    color: #FFFFFF !important;
    font-size: 14px !important;
}

.data-table-eval-report thead th:first-child {
    border-radius: 10px 0 0 0;
}

.data-table-eval-report thead th:last-child {
    border-radius: 0 10px 0 0;
}

.data-table-eval-report thead th {
    font-size: 14px !important;
    font-weight: 400;
}

.data-table-eval-report .v-data-table__wrapper table tbody tr td {
    padding-top: 0px;
    font-size: 12px;
    height: 49px !important;
}

.data-table-eval-report tbody tr td {
    border-bottom: 0px !important;
}

.data-table-eval-report tbody tr td:first-child {
    border-left: 0px !important;
    border-bottom: 0px !important;
}

.data-table-eval-report tbody tr td:last-child {
    border-right: 0px !important;
    border-bottom: 0px !important;
}

.data-table-eval-report .v-data-table__wrapper table tbody tr td {
    border-left: none !important;
}

.data-table-eval-report.v-data-table>.v-data-table__wrapper::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: transparent !important;
}

.data-table-eval-report.v-data-table>.v-data-table__wrapper::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: transparent !important;
}

.data-table-eval-report.v-data-table>.v-data-table__wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #0903035e;
}

.data-table-eval-report .v-data-table__wrapper {
    max-height: calc(100vh - 257px);
    height: 100%;
    overflow-y: auto;

}
.data-table-eval-report.v-data-table>.v-data-table__wrapper {
    height: calc(100vh - 259px);
    overflow: auto;
    scroll-behavior: smooth;
}
</style>